import { render, staticRenderFns } from "./lender-transactions-container-loader.vue?vue&type=template&id=f4242162"
import script from "./lender-transactions-container-loader.vue?vue&type=script&lang=js"
export * from "./lender-transactions-container-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports